import { Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { 
  AUTH0_DOMAIN, 
  AUTH0_AUDIENCE, 
  AUTH0_PARENT_CLIENT_ID 
} from '@/lib/auth0-config';

interface ParentAuth0ProviderProps {
  children: ReactNode;
}

/**
 * Auth0 Provider wrapper for Parent routes
 * Uses the parent-specific Auth0 application
 */
export function ParentAuth0Provider({ children }: ParentAuth0ProviderProps) {
  const redirectUri = `${globalThis.location.origin}/auth/callback/parent`;
  
  console.log('ParentAuth0Provider mounting with:', {
    domain: AUTH0_DOMAIN,
    clientId: AUTH0_PARENT_CLIENT_ID,
    redirectUri,
    audience: AUTH0_AUDIENCE
  });

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_PARENT_CLIENT_ID}
      authorizationParams={{ 
        redirect_uri: redirectUri,
        ...(AUTH0_AUDIENCE ? { audience: AUTH0_AUDIENCE } : {}),
        scope: 'openid profile email'
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
